﻿import { ValgState } from './Store/Valg/Types';

export const getA = (state: ValgState): string | undefined => {
    return state.aUtdanning?.value;
};

export const getB = (state: ValgState): string | undefined => {
    return state.bGrad?.value;
};

export const getBx = (state: ValgState): string | undefined => {
    return state.bxGrad?.value;
};
